import { InjectionToken } from '@angular/core';
import { StockMovementModel } from '../models/stockMovement';

/**
 * Abstraktion der Order-Movement-Queue für die Inventory-Helper.
 * Entkoppelt die warehouse-Helper von der konkreten OrderMovementsQueueService,
 * die in app/pages liegt - die Implementierung wird per Token bereitgestellt.
 */
export interface IMovementQueue {
  enqueueMovement(movement: StockMovementModel): void;
}

export const MOVEMENT_QUEUE = new InjectionToken<IMovementQueue>('MovementQueue');
